module.exports = __webpack_public_path__ + "media/theme/success__hanabi-8d7d3976.png";